import type { AtualizarClienteDto, ClienteResponse, CriarClienteDto, ListarClientesQuery } from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

export function useClientes(q: Partial<ListarClientesQuery> = {}) {
  return useConsulta<ClienteResponse[]>(['clientes'], '/clientes', { query: q });
}

export function useCliente(id: string | undefined) {
  return useConsulta<ClienteResponse>(['clientes', id], `/clientes/${id}`, { ativo: !!id });
}

/** Cria cliente: com `parceiroId` usa o parceiro ja existente (sem nome). Invalida fornecedores: o papel aparece la tambem. */
export function useCriarCliente() {
  return useMutacao<ClienteResponse, CriarClienteDto>({
    metodo: 'POST', caminho: () => '/clientes', corpo: (v) => v, invalidar: [['clientes'], ['fornecedores']],
  });
}

export function useAtualizarCliente() {
  return useMutacao<ClienteResponse, { id: string } & AtualizarClienteDto>({
    metodo: 'PATCH',
    caminho: (v) => `/clientes/${v.id}`,
    corpo: ({ id: _id, ...resto }) => resto,
    invalidar: [['clientes']],
  });
}
